import * as actions from './actions';
import reducers from './reducer';

export const Playlist = { actions, reducers };
export { PlaylistState } from './reducer';
